export default __webpack_public_path__ + "static/media/beef_stir_fry.036c6406.jpg";